import React from 'react';
import { useSelector } from 'react-redux';

// components
import { TextInput, TextBlock, Checkbox } from '../components/inputs';
import { FormRow } from '../components/layout';

function Address() {
  const { samemail } = useSelector(store => store.values);

  return (
    <div>
      <FormRow className="mb-0" showIfFieldExists="address_extra_text">
        <TextBlock name="address_extra_text" />
      </FormRow>
      <FormRow>
        <TextInput
          label="Home address line 1"
          name="street1"
        />
      </FormRow>
      <FormRow>
        <TextInput
          label="Home address line 2"
          name="street2"
        />
      </FormRow>
      <FormRow>
        <TextInput
          cols="6"
          label="City"
          name="city"
          disabled
        />
        <TextInput
          cols="6"
          label="State"
          name="state"
          disabled
        />
      </FormRow>
      <FormRow>
        <TextInput
          cols="6"
          label="Zip code"
          name="zipcode"
          disabled
        />
        <TextInput
          cols="6"
          label="County"
          name="county_name"
          disabled
        />
      </FormRow>

      {/* Mailing Address */}

      <FormRow>
        <Checkbox
          label="Mailing address same as home address"
          name="samemail"
          unsetFieldsOnFalse={[
            'mailstreet1',
            'mailstreet2',
            'mailcity',
            'mailstate',
            'mailzip',
          ]}
        />
      </FormRow>
      <FormRow>
        <TextInput
          label="Mailing address line 1"
          clone={samemail ? 'street1' : ''}
          name="mailstreet1"
          disabled={samemail}
        />
      </FormRow>
      <FormRow>
        <TextInput
          label="Mailing address line 2"
          clone={samemail ? 'street2' : ''}
          name="mailstreet2"
          disabled={samemail}
        />
      </FormRow>
      <FormRow>
        <TextInput
          cols="6"
          clone={samemail ? 'city' : ''}
          label="City"
          name="mailcity"
          disabled={samemail}
        />
        <TextInput
          cols="6"
          clone={samemail ? 'state' : ''}
          label="State"
          name="mailstate"
          disabled={samemail}
        />
      </FormRow>
      <FormRow>
        <TextInput
          cols="6"
          clone={samemail ? 'zipcode' : ''}
          label="Zip code"
          name="mailzip"
          disabled={samemail}
        />
      </FormRow>
    </div>
  );
}

export default Address;
